module.exports = "\r\n.martop20{\r\n    margin-top: 20px;\r\n    \r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/reports/appreport/appreport.component.css
// module id = ./src/app/reports/appreport/appreport.component.css
// module chunks = main